import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.slice";
import "core-js/modules/es6.array.filter";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
import _findIndex from "lodash/findIndex";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { combineReducers } from 'redux';
import { YodleeSearchFallback } from "../../constants/yodlee";
import { attemptProviderMFA, chooseUnavailableProvider, closeYodleeOnboarding, fetchYodleeProfile, getPortalMigrationDetails, getProviderAccountStatus, getProviderDetails, loginFormFieldChanged, loginToProvider, markYodleeOnboardingAsComplete, mfaFormFieldChanged, readYodleeProfile, requestIdentity, resetYodleeOnboarding, retryYodleeOnboarding, selectProvider, selectProviderAccount, setYodleeSearchFallback, startYodleeOnboarding } from "../../actions";
import { RESET_PLAID_ONBOARDING, reinitializePortal, setIsYodleeToPlaidMigrationEnabled } from "../../actions/financial-data";
import createFormReducer from "./create-form-reducer";
export var selectedProviderId = function selectedProviderId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  if (type === selectProvider.getType()) {
    return _get(payload, 'externalId');
  } // startYodleeOnboarding may optionally pass a provider id to "preselect"


  if (type === startYodleeOnboarding.getType() && _get(payload, 'providerId')) {
    return _get(payload, 'providerId');
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
};
/**
 * Stores the selected "provider" as shaped by
 * institution-search.jsx#getSearchResultFromAccountLinkingInstitution()
 */

export var selectedProvider = function selectedProvider() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case chooseUnavailableProvider.getType():
    case selectProvider.getType():
      // should only be called by the Plaid FDP flow
      return payload;

    case closeYodleeOnboarding.getType():
    case resetYodleeOnboarding.getType():
    case retryYodleeOnboarding.getType():
    case RESET_PLAID_ONBOARDING:
      return null;

    default:
      return state;
  }
};
export var selectedProviderAccountId = function selectedProviderAccountId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref3.type,
      payload = _ref3.payload;

  if (type === selectProviderAccount.getType()) return payload; // startYodleeOnboarding may optionally pass a provider account id to "preselect"

  if (type === startYodleeOnboarding.getType()) {
    var _payload$providerAcco;

    return (_payload$providerAcco = payload === null || payload === void 0 ? void 0 : payload.providerAccountId) !== null && _payload$providerAcco !== void 0 ? _payload$providerAcco : null;
  }

  if (type === loginToProvider.SUCCESS_TYPE && _get(payload, 'provider_account_id')) {
    return payload.provider_account_id;
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === retryYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
}; // Keep track of any async action failures that are related to Yodlee
// onboarding. This state being populate may indicate an error should be shown
// to the user. See related selectors in src/selectors/yodlee.js.

export var lastAsyncError = function lastAsyncError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case selectProviderAccount.getType():
    case retryYodleeOnboarding.getType():
    case closeYodleeOnboarding.getType():
    case RESET_PLAID_ONBOARDING:
    case resetYodleeOnboarding.getType():
    case loginToProvider.START_TYPE:
    case attemptProviderMFA.START_TYPE:
      return null;

    case getProviderDetails.FAIL_TYPE:
    case loginToProvider.FAIL_TYPE:
    case attemptProviderMFA.FAIL_TYPE:
    case getProviderAccountStatus.FAIL_TYPE:
    case requestIdentity.FAIL_TYPE:
      return {
        action: type,
        error: payload
      };

    default:
      return state;
  }
}; // whether yodlee onboarding has been marked as complete. Used in the web flow when the user
// select "ok" from the success step. Not used for mobile.

export var isComplete = function isComplete() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref5.type;

  if (type === markYodleeOnboardingAsComplete.getType()) return true;
  if (type === closeYodleeOnboarding.getType()) return false;
  if (type === resetYodleeOnboarding.getType()) return false;
  if (type === RESET_PLAID_ONBOARDING) return false;
  return state;
}; // provider type for the top 8 providers that are shown on the provider search step.

export var topProviderType = function topProviderType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref6 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref6.type,
      payload = _ref6.payload;

  if (type === startYodleeOnboarding.getType() && _get(payload, 'topProviderType')) {
    return _get(payload, 'topProviderType');
  }

  if (type === closeYodleeOnboarding.getType()) return null;

  if (type === resetYodleeOnboarding.getType() && (payload === null || payload === void 0 ? void 0 : payload.preserveProviderType) !== true) {
    return null;
  }

  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
}; // skip error screen flag used to go directly to log in / MFA screen(s)

export var shouldSkipErrorScreen = function shouldSkipErrorScreen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref7 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref7.type,
      payload = _ref7.payload;

  if (type === startYodleeOnboarding.getType() && _get(payload, 'shouldSkipErrorScreen')) {
    return _get(payload, 'shouldSkipErrorScreen');
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
};

var updateYodleeProviderAccountState = function updateYodleeProviderAccountState(state, payload) {
  var _state$slice, _state$slice2;

  // Some actions like attemptProviderIAV do not return the provider_account_state
  // so we need to use the provider_id returned from the endpoints to find the provider account.
  var providerId = payload.provider_id;

  var index = _findIndex(state, function (pa) {
    var _pa$provider_account_, _pa$provider_account_2;

    return (pa === null || pa === void 0 ? void 0 : (_pa$provider_account_ = pa.provider_account_state) === null || _pa$provider_account_ === void 0 ? void 0 : (_pa$provider_account_2 = _pa$provider_account_.provider) === null || _pa$provider_account_2 === void 0 ? void 0 : _pa$provider_account_2.id) === providerId;
  });

  var position = index === -1 ? state === null || state === void 0 ? void 0 : state.length : index;
  var existingProviderAccount = index === -1 ? {} : state[index];
  return [].concat(_toConsumableArray((_state$slice = state === null || state === void 0 ? void 0 : state.slice(0, position)) !== null && _state$slice !== void 0 ? _state$slice : []), [_objectSpread(_objectSpread({}, existingProviderAccount), {}, {
    provider_account_state: payload
  })], _toConsumableArray((_state$slice2 = state === null || state === void 0 ? void 0 : state.slice(position + 1)) !== null && _state$slice2 !== void 0 ? _state$slice2 : [])).filter(Boolean);
};
/**
 * Stores the list of the user's Yodlee provider_accounts from their yodlee_profile.
 *
 * @param {Object} state - the current redux state
 * @param {Object} action - the action being dispatched
 */


export var providerAccounts = function providerAccounts() {
  var _payload$data;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref8 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref8.type,
      payload = _ref8.payload;

  switch (type) {
    case fetchYodleeProfile.SUCCESS_TYPE:
      return payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.provider_accounts;

    case readYodleeProfile.SUCCESS_TYPE:
      {
        var data = payload.data; // do not override mfa_form or provider because that info exists only in identity

        if (state) {
          var _data$provider_accoun;

          var prevProviderAccountsByPasId = state.reduce(function (acc, pa) {
            acc[pa.provider_account_state.id] = pa;
            return acc;
          }, {});
          return ((_data$provider_accoun = data === null || data === void 0 ? void 0 : data.provider_accounts) !== null && _data$provider_accoun !== void 0 ? _data$provider_accoun : []).map(function (pa) {
            var prevPa = prevProviderAccountsByPasId[pa.provider_account_state.id];

            if (!prevPa) {
              return pa;
            } // do not override error_resolutions.primary_action because it may be ephemerally `MIGRATE`
            // from calling FDP Proxy /fix (reinitializePortal action)


            var nextPrimaryErrorResolution = prevPa.provider_account_state.error_resolutions.primary_action === 'MIGRATE' ? prevPa.provider_account_state.error_resolutions.primary_action : pa.provider_account_state.error_resolutions.primary_action;
            return _objectSpread(_objectSpread({}, pa), {}, {
              provider_account_state: _objectSpread(_objectSpread({}, pa.provider_account_state), {}, {
                error_resolutions: _objectSpread(_objectSpread({}, pa.provider_account_state.error_resolutions), {}, {
                  primary_action: nextPrimaryErrorResolution
                }),
                mfa_form: prevPa.provider_account_state.mfa_form,
                provider: prevPa.provider_account_state.provider
              })
            });
          });
        }

        return data === null || data === void 0 ? void 0 : data.provider_accounts;
      }

    case reinitializePortal.SUCCESS_TYPE:
      {
        var _payload$data$reiniti, _payload$data2, _payload$data2$reinit;

        var _ref9 = (_payload$data$reiniti = payload === null || payload === void 0 ? void 0 : (_payload$data2 = payload.data) === null || _payload$data2 === void 0 ? void 0 : (_payload$data2$reinit = _payload$data2.reinitializeFinancialPortal) === null || _payload$data2$reinit === void 0 ? void 0 : _payload$data2$reinit.financialPortal) !== null && _payload$data$reiniti !== void 0 ? _payload$data$reiniti : {},
            id = _ref9.id,
            primaryClientAction = _ref9.primaryClientAction;

        var paIndex = _findIndex(state, function (pa) {
          return pa.provider_account_state.id === id;
        });

        var updatedProviderAccount = _cloneDeep(state[paIndex]);

        _set(updatedProviderAccount, 'provider_account_state.error_resolutions.primary_action', primaryClientAction);

        return [].concat(_toConsumableArray(state.slice(0, paIndex)), [updatedProviderAccount], _toConsumableArray(state.slice(paIndex + 1)));
      }

    case loginToProvider.SUCCESS_TYPE:
    case attemptProviderMFA.SUCCESS_TYPE:
      return updateYodleeProviderAccountState(state, payload);

    default:
      return state;
  }
};

var migrationDetails = function migrationDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref10 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref10.type,
      payload = _ref10.payload;

  switch (type) {
    case reinitializePortal.SUCCESS_TYPE:
      {
        var _payload$data3, _payload$data3$reinit, _payload$data3$reinit2;

        var recommendedInstitutionId = payload === null || payload === void 0 ? void 0 : (_payload$data3 = payload.data) === null || _payload$data3 === void 0 ? void 0 : (_payload$data3$reinit = _payload$data3.reinitializeFinancialPortal) === null || _payload$data3$reinit === void 0 ? void 0 : (_payload$data3$reinit2 = _payload$data3$reinit.details) === null || _payload$data3$reinit2 === void 0 ? void 0 : _payload$data3$reinit2.recommendedInstitutionId;
        return recommendedInstitutionId ? {
          recommendedMarketplaceInstitutionId: recommendedInstitutionId
        } : null;
      }

    case getPortalMigrationDetails.SUCCESS_TYPE:
      {
        var _payload$data$financi, _payload$data4, _payload$data4$financ;

        return (_payload$data$financi = payload === null || payload === void 0 ? void 0 : (_payload$data4 = payload.data) === null || _payload$data4 === void 0 ? void 0 : (_payload$data4$financ = _payload$data4.financialPortalById) === null || _payload$data4$financ === void 0 ? void 0 : _payload$data4$financ.migrationDetails) !== null && _payload$data$financi !== void 0 ? _payload$data$financi : null;
      }

    case closeYodleeOnboarding.getType():
    case RESET_PLAID_ONBOARDING:
      return null;

    case resetYodleeOnboarding.getType():
      // This will only get called with a non-preserveProviderType payload if we are resetting for search_to_migrate
      // it sets some bare necessities for furthering the flow, since /fix doesn't return migration details in this case
      if (payload && typeof payload.preserveProviderType === 'undefined') {
        return payload;
      }

      return null;

    default:
      return state;
  }
};

var isYodleeToPlaidMigrationEnabled = function isYodleeToPlaidMigrationEnabled() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref11 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref11.type,
      isEnabled = _ref11.payload;

  if (type === setIsYodleeToPlaidMigrationEnabled.getType()) {
    return isEnabled;
  }

  return state;
};
/**
 * Holds a value from the YodleeSearchFallback enum
 */


export var yodleeSearchFallback = function yodleeSearchFallback() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : YodleeSearchFallback.NONE;

  var _ref12 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref12.type,
      payload = _ref12.payload;

  switch (type) {
    case setYodleeSearchFallback.getType():
      return payload;

    case closeYodleeOnboarding.getType():
    case RESET_PLAID_ONBOARDING:
    case resetYodleeOnboarding.getType():
      return null;

    default:
      return state;
  }
};
export default combineReducers({
  isComplete: isComplete,
  isYodleeToPlaidMigrationEnabled: isYodleeToPlaidMigrationEnabled,
  lastAsyncError: lastAsyncError,
  loginForm: createFormReducer(loginFormFieldChanged.getType()),
  providerAccounts: providerAccounts,
  mfaForm: createFormReducer(mfaFormFieldChanged.getType()),
  migrationDetails: migrationDetails,
  selectedProvider: selectedProvider,
  selectedProviderAccountId: selectedProviderAccountId,
  selectedProviderId: selectedProviderId,
  shouldSkipErrorScreen: shouldSkipErrorScreen,
  topProviderType: topProviderType,
  yodleeSearchFallback: yodleeSearchFallback
});